import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import { showError, showSuccess } from 'utils/utils';
import { deleteDocument } from 'services/myOrders';
import withErrorBoundary from '../../withErrorBoundary';
import ConfirmDialog from '../../ConfirmDialog';

interface MoDeleteDocumentProps {
  orderId: number;
  segId: number;
  documentId: number;
  onDocumentDeleted?: (documentId: number) => void;
}

const MoDeleteDocument: FC<MoDeleteDocumentProps> = ({
  orderId,
  segId,
  documentId,
  onDocumentDeleted,
}) => {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);

  const handleDelete = async () => {
    const params = {
      orderId,
      segId,
      documentId,
    };

    const response = await deleteDocument(params);
    if (response?.deleted) {
      showSuccess(t('mo.document_deleted'));
      onDocumentDeleted?.(documentId);
    } else {
      showError(t('something_went_wrong'));
    }
    setOpenModal(false);
  };

  return (
    <>
      <Button
        title="Delete"
        onClick={() => setOpenModal(true)}
        className="btn btn-danger btn-ssm"
      />
      <ConfirmDialog
        title={t('mo.delete_document') || 'Delete Document'}
        openModal={openModal}
        close={() => setOpenModal(false)}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default withErrorBoundary(MoDeleteDocument, 'MoDeleteDocument');
